import './travel-info-bar.scss';

import { checkAndLoadFiles, createElementFromHTML, getOffset } from '../../utilities/js/helper';
import AjaxLoad from '../../utilities/js/ajax-load';

class TravelInfoBar {
    constructor (element) {
        this.$travelInfoBar = element;
        this.$indicator = this.$travelInfoBar.previousElementSibling;
        this.$footer = document.querySelector('[data-sitefooter="root"]');
        this.$printButton = this.$travelInfoBar.querySelector('[data-travel-detail-print]');
        this.$printTarget = document.querySelector('[data-print-target]');
        this.$$travelExtensionTeasers = document.querySelectorAll('[data-modal="travel_extension_details"]');
        this.$$tabNavUrls = document.querySelectorAll('[data-tab-nav-url]');
        this.$flyoutToggle = document.querySelector('[data-travel-info-bar="toggle"]');
        this.$highlightIcon = document.querySelector('.highlight-icon');

        if (this.$highlightIcon) {
            this.$highlightIconParent = this.$highlightIcon.parentElement;
            this.$highlightIconSibling = this.$highlightIcon.nextElementSibling;
        }

        this.subPagesLoaded = false;
        this.initial = true;
    }

    initialize () {
        this.checkPosition();

        this.setEvents();
    }

    setEvents () {
        window.eventScroller.customFunctions.push(() => {
            this.checkPosition();
            this.initial = false;
        });

        if (this.$printButton) {
            this.$printButton.addEventListener('click', () => {
                if (this.$printTarget) {
                    if (this.$$tabNavUrls.length > 0) {
                        if (!this.subPagesLoaded) {
                            this.subPagesLoaded = true;
                            this.setTravelExtensionDetails();
                            this.$$tabNavUrls.forEach((item, index) => this.sendRequest(item.dataset.tabNavUrl, index));
                        } else {
                            this.$printTarget.style.display = 'block';
                            window.print();
                        }
                    } else {
                        this.setTravelExtensionDetails();
                        this.$printTarget.style.display = 'block';
                        window.print();
                    }
                }
            });
        }

        window.addEventListener('print.ready', (e) => {
            this.$printTarget.style.display = 'block';
            window.print();
        });

        window.addEventListener('afterprint', () => {
            this.$printTarget.style.display = '';
            this.removeTravelExtensionDetails();
            this.restoreHighlightIcon();
        });
    }

    setTravelExtensionDetails () {
        if (this.$$travelExtensionTeasers.length > 0 && this.$printTarget) {
            this.$$travelExtensionTeasers.forEach((teaser) => {
                if (teaser.dataset.modalContentJson) {
                    try {
                        const content = JSON.parse(teaser.dataset.modalContentJson);
                        const $contentElement = createElementFromHTML(content);
                        const $wrapper = document.createElement('div');

                        $wrapper.classList.add('travel-extension-details__print-wrapper', 'is--travel-extension-print-content');

                        if ($contentElement.length > 1) {
                            $contentElement.forEach((item) => {
                                $wrapper.appendChild(item);
                            });
                        } else {
                            $wrapper.appendChild($contentElement);
                        }

                        this.$printTarget.appendChild($wrapper);
                    } catch (e) {
                        console.error('Error parsing travel extension content', e);
                    }
                }
            });

            this.moveHighlightIconToEnd();
        }
    }

    removeTravelExtensionDetails () {
        if (this.$printTarget) {
            const $$addedContents = this.$printTarget.querySelectorAll('.is--travel-extension-print-content');
            $$addedContents.forEach((content) => {
                content.remove();
            });
        }
    }

    sendRequest (url, index) {
        this.result = new AjaxLoad(url, {
            requestMethod: 'post',
            onSuccess: (resultText) => {
                this.setResult(resultText, index);
            },
            onError: (error) => {
                console.warn(error);
            }
        });
    }

    setResult (results, index) {
        const $result = createElementFromHTML(results);

        if ($result.length > 1) {
            $result.forEach((item) => {
                this.$printTarget.appendChild(item);
            });
        } else {
            this.$printTarget.appendChild($result);
        }

        this.moveHighlightIconToEnd();

        checkAndLoadFiles(this.$printTarget).then((data) => {
            window.dispatchEvent(new CustomEvent('content.loaded', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: this.$printTarget,
                    ajax: true
                }
            }));

            if (index + 1 === this.$$tabNavUrls.length) {
                window.dispatchEvent(new CustomEvent('print.ready', {
                    view: window,
                    bubbles: true,
                    cancelable: false
                }));
            }
        });
    }

    moveHighlightIconToEnd () {
        if (this.$printTarget && this.$highlightIcon) {
            this.$printTarget.appendChild(this.$highlightIcon);
        }
    }

    restoreHighlightIcon () {
        if (this.$highlightIcon && this.$highlightIconParent) {
            if (this.$highlightIconSibling) {
                this.$highlightIconParent.insertBefore(this.$highlightIcon, this.$highlightIconSibling);
            } else {
                this.$highlightIconParent.appendChild(this.$highlightIcon);
            }
        }
    }

    checkPosition () {
        if ((window.scrollPosition + window.innerHeight) >= (getOffset(this.$indicator).top + this.$travelInfoBar.scrollHeight)) {
            this.$indicator.classList.add('is--visible');

            if ((window.scrollPosition + window.innerHeight) > getOffset(this.$footer).top) {
                this.$indicator.classList.remove('is--visible');
            } else {
                this.$indicator.classList.add('is--visible');
            }
        } else {
            if (this.$indicator.classList.contains('is--visible')) {
                this.$indicator.classList.remove('is--visible');
            }
        }

        if (this.$flyoutToggle && !this.initial) {
            if (this.$flyoutToggle.checked === (window.scrollDirection === 'down')) {
                this.$flyoutToggle.checked = !this.$flyoutToggle.checked;
            }
        }
    }
}

export { TravelInfoBar };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $travelInfoBar = $context.querySelector('[data-travel-info-bar="root"]');

        if ($travelInfoBar) {
            const travelInfoBar = new TravelInfoBar($travelInfoBar);
            travelInfoBar.initialize();
        }
    }
});
